import React, { Component } from "react";
import ReactDOM from 'react-dom';
import RecycleBinTable from "./RecycleBinTable";

class RecycleLogModal extends Component {
    openModal = () => {
        if (this.tableRef?.openModal) {
            this.tableRef.openModal();
        }
    }

    render() {
        return (
            <RecycleBinTable
                ref={(ref) => { this.tableRef = ref; }}
                modalId="recycleLogModal"
                title="Tipos de documentos"
                logView={true}
                person_provider_id={this.props.person_provider_id}
            />
        );
    }
}

export default RecycleLogModal;

if (document.getElementById('RecycleLogModal')) {
    ReactDOM.render(<RecycleLogModal />, document.getElementById('RecycleLogModal'));
}
